export enum State {
  CREATE,
  EDIT,
}

export enum NoteDisplayMode {
  EDIT = 'edit',
  DISCARD = 'discard',
  DELETE = 'delete',
}

export enum EditCardEvents {
  CLOSE_WINDOW = 'closeEditWindow',
  EDIT_NOTE = 'editNote',
  CREATE_NOTE = 'createNote',
  DELETE_NOTE = 'deleteNote',
}
